import { DateTime } from 'luxon';

import { AdCampaignItemResponse } from 'apis/ad-bookings/types';
import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';

import { CampaignListItem, CampaignStatus } from '../../types';
import { getCampaignActions } from '../getCampaignActions';

export const transformApiAdCampaignListItemToCampaignListItem = (
  campaign: AdCampaignItemResponse,
  country: Country,
  currency: Currency,
  venueId: string,
  isMerchantLevel: boolean,
): CampaignListItem => {
  return {
    campaignId: campaign.id,
    campaignType: CampaignType.ADS,
    startDate: DateTime.fromISO(campaign.start_date).toISO(),
    endDate: campaign.end_date ? DateTime.fromISO(campaign.end_date).toISO() : undefined,
    budget: convertMonetaryIntToDecimal(Number(campaign.weekly_budget_amount), currency),
    status: campaign.status.toLowerCase() as CampaignStatus,
    lastSevenDaysOrders: campaign.last_seven_days_purchases?.order_count,
    totalOrders: campaign.total_purchases?.order_count,
    lastSevenDaysSpend: convertMonetaryIntToDecimal(
      campaign.last_seven_days_purchases?.budget_spend_amount || 0,
      currency,
    ),
    totalSpend: convertMonetaryIntToDecimal(campaign.total_purchases?.budget_spend_amount || 0, currency),
    lastSevenDaysSales: campaign.last_seven_days_purchases?.sales_amount
      ? convertMonetaryIntToDecimal(campaign.last_seven_days_purchases.sales_amount, currency)
      : undefined,
    totalSales: campaign.total_purchases?.sales_amount
      ? convertMonetaryIntToDecimal(campaign.total_purchases.sales_amount, currency)
      : undefined,
    allowedActions: getCampaignActions({
      campaignType: CampaignType.ADS,
      campaignStatus: campaign.status.toLocaleLowerCase() as CampaignStatus,
      country,
      creationSource: campaign.read_only ? 'opsTools' : 'merchantAdmin',
      isMerchantLevel,
      venueIds: [venueId],
    }),
    paidBy: campaign.paid_by,
    venueIds: [venueId],
    creationSource: campaign.read_only ? 'opsTools' : 'merchantAdmin',
  };
};
